/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JobServiceAccount {
    getFixupPrototypeFunction() { return JobServiceAccount.fixupPrototype; }

    static newInstance(model: Partial<JobServiceAccount>): JobServiceAccount {
        let obj = Object.assign(new JobServiceAccount(), model);
        JobServiceAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JobServiceAccount>): JobServiceAccount {
        if (!model) return null;
        return JobServiceAccount.newInstance(<JobServiceAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JobServiceAccount) {
        if (!obj) return;

        models.JobServiceAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JobServiceAccount): boolean {
        Object.setPrototypeOf(obj, JobServiceAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service account ID
     */
    id: string;

}
